<template>
   <div style="background-color: white;">
   
      <div style="max-width: 1000px; margin: auto; padding-bottom: 35px">
         <div style="padding-top: 30px; text-align: center; font-size: 45px; padding-left: 20px; padding-right: 20px">
            <!-- <p><strong>{{ $t('Welcome to Goal Traders by Sospeso!') }}</strong></p> -->
            <p><strong>{{ $t('Welcome!') }}</strong></p>
         </div>
        
         <section style="background-color: #DCF9C4A3; text-align: center; margin-top: 40px; margin-left: 15px; margin-right: 15px;">
            <div class="section-header">
               <p>{{ $t('How to start ?') }}</p>
            </div>
            <div class = 'section-content'>
               <p>{{ $t('It is important to start with the right foot: for a better trading experience have a look on user’s video tutorial.') }}</p>
            </div>
            <div style="padding-bottom: 33px; margin-top: -25px"> <a :href="tutorial_url" class="show_video" role="button" target="_blank"> 
               
               <span style="justify-content: center; color: white; font-size: 18px; margin-top: 11px; display: inline-block; line-height: 1em; ">Click here</span>
                </a>
             </div>
         </section>

         <!-- <section style="background-color: #F8E8E8; text-align: center; margin-top: 40px; margin-left: 15px; margin-right: 15px;">
            <div class="section-header">
               <p>{{ $t('What’s new ?') }}</p>
            </div>
           <div class = 'section-content'>
               <p>{{ $t('The best platform tool for sport trading is here! Goal Traders by Sospeso is always updated to give you the best that you can have. We will let you know here if some updating is coming soon…') }}</p>
            </div>
            
         </section> -->

          <section style="background-color: #ECF1FB; text-align: center; margin-top: 40px; margin-left: 15px; margin-right: 15px;">
            <div class="section-header">
               <p>{{ $t('Let’s keep in touch') }}</p>
            </div>
           <div class = 'section-content'>
               <p>{{ $t('For every support that you need you can contact us to:') }}</p>
               <p><strong><span class="email_font" style="text-decoration: underline;">info.goaltraders@sospesosoftwares.com</span></strong></p>
            </div>
            
         </section>

         <section style="background-color: #ECFF6F85; text-align: center; margin-top: 40px; margin-left: 15px; margin-right: 15px;">
            <div class="section-header">
               <p>{{ $t('Our social channels') }}</p>
            </div>
            <div class = 'section-content'>
              <a v-if="instagram.check && instagram.url" class="elementor-icon" :href="instagram.url" target="_blank"> <img src="/img/instagram.256x256.png" itemprop="contentUrl" loading="lazy" class="icon loaded social-link" alt="instagram" title="instagram" > </a>

              <a v-if="facebook.check && facebook.url" class="elementor-icon" :href="facebook.url" target="_blank"> <img src="https://static-00.iconduck.com/assets.00/facebook-round-icon-96x96-id60d6hb.png" srcset="https://static-00.iconduck.com/assets.00/facebook-round-icon-96x96-id60d6hb.png 1x, https://static-00.iconduck.com/assets.00/facebook-round-icon-96x96-id60d6hb.png 2x, https://static-00.iconduck.com/assets.00/facebook-round-icon-96x96-id60d6hb.png 3x, https://static-00.iconduck.com/assets.00/facebook-round-icon-128x128-oq6pj9af.png 4x, https://static-00.iconduck.com/assets.00/facebook-round-icon-144x144-4z6skbrh.png 4.5x" itemprop="contentUrl" loading="lazy" class="icon loaded social-link"  alt="facebook" title="facebook" data-alternate="https://d1rs1tqcxzgl1z.cloudfront.net/iconduck/image/upload/w_115,h_115,c_fit/f_png/e_colorize:0,co_rgb:000000/w_120,h_120,c_lpad/e_trim:1/w_96,h_96,c_fit/s3.prod/assets.00/asst67xbffo8"> </a>

              <a v-if="whatsapp.check && whatsapp.url" class="elementor-icon" :href="whatsapp.url" target="_blank"> <img src="/img/whatsapp.256x256.png" itemprop="contentUrl" loading="lazy" class="icon loaded social-link" alt="whatsapp" title="whatsapp" > </a>

              <a v-if="youtube.check && youtube.url" class="elementor-icon" :href="youtube.url" target="_blank"> <img src="https://static-00.iconduck.com/assets.00/youtube-icon-96x68-nqgn8bds.png" srcset="https://static-00.iconduck.com/assets.00/youtube-icon-96x68-nqgn8bds.png 1x, https://static-00.iconduck.com/assets.00/youtube-icon-96x68-nqgn8bds.png 2x, https://static-00.iconduck.com/assets.00/youtube-icon-96x68-nqgn8bds.png 3x, https://static-00.iconduck.com/assets.00/youtube-icon-128x90-sniep163.png 4x, https://static-00.iconduck.com/assets.00/youtube-icon-144x101-jlmqnopt.png 4.5x" itemprop="contentUrl" loading="lazy" class="icon loaded social-link" alt="youtube" title="youtube" data-alternate="https://d1rs1tqcxzgl1z.cloudfront.net/iconduck/image/upload/w_115,h_115,c_fit/f_png/e_colorize:0,co_rgb:000000/w_120,h_120,c_lpad/e_trim:1/w_96,h_96,c_fit/s3.prod/assets.00/asstxu8mioxt"> </a>

              <a v-if="telegram.check && telegram.url" class="elementor-icon" :href="telegram.url" target="_blank"> <img src="/img/image_2022_04_21T18_06_25_457Z.png" itemprop="contentUrl" loading="lazy" class="icon loaded social-link" alt="telegram" title="telegram" > </a>
            </div>
         </section>
      </div>
       <b-modal
            :title="$t('Settings and profile options')"
            id="b-modal"
            @ok="handleOk"            
        >
           <div>
               <div class="setting_card">
                  <div style="display: flex;">
                     <div style="flex: 0.5; padding-right: 10px">
                       <div class="form-group ">
                            <label style="float: left; margin-top: 6px; margin-right: 5px;">{{ $t('Username') }}</label>
                              <CInput class="odd-filter-inputbox" :value="loggedInUser.display_name" readonly></CInput>
                        </div>
                     </div>
                     <div style="flex: 0.5; padding-left: 10px">
                        <div class="form-group ">
                              <label style="float: left; margin-top: 6px; margin-right: 5px;">{{ $t('Currency') }}</label>
                              <CSelect
                                  :value.sync = "mycurrency"
                                  :options= "currency_list"
                              >
                              </CSelect>
                        </div>
                     </div>
                     <hr class="profile_hr"/>
                  </div>
                  <div style="display: flex;">
                     <div style="flex: 0.5; padding-right: 10px">
                       <div class="form-group user-avatar-wrapper">
                           <label class="select_avatar_label">{{ $t('Select Avatar') }}</label>
                           <div class="user-avatar">
                               <cropper
                                   :boundary="{
                                       width: 220,
                                       height: 220
                                   }"
                                   :viewport="{
                                       width: 200,
                                       height: 200
                                   }"
                                   :resize="false"
                                   :defaultAvatarSrc="imageUrl"
                                   :zoom="true"
                                   @cropped="cropped"
                               />
                           </div>
                       </div>
                     </div>
                     <div style="flex: 0.5; padding-left: 10px">
                        <div class="form-group ">
                           <label style="float: left; margin-top: 6px; margin-right: 5px;">{{ $t('Language') }}</label>
                           <CSelect
                               :value.sync = "mylang"
                               :options = "lang_list"
                               @update:value = "changeLocale"

                           >
                           </CSelect>
                        </div>
                     </div>
                     <hr class="profile_hr"/>
                  </div>
                  <div style="display: flex;">
                     <div style="flex: 0.5; padding-right: 10px">
                        <div class="form-group ">
                           <label style="float: left; margin-top: 6px; margin-right: 5px;">{{ $t('Alias') }}:</label>
                          <CInput
                              class="alias_label"
                              :key="JSON.stringify(loggedInUser)"
                              
                              :value="model.alias"
                              :isValid="validationState['alias'] && validationState['alias'].state"
                              :invalidFeedback="validationState['alias'] && validationState['alias'].text"
                              @update:value="model.alias=$event, validateField('alias')"
                          />
                       </div>
                     </div>
                     <div style="flex: 0.5; padding-left: 10px">
                        <div class="form-group ">
                           <label style="float: left; margin-top: 6px; margin-right: 5px;">{{ $t('Timezone') }}:</label>
                           <CSelect
                               :value.sync = "mytimezone"
                               :options = "timezone_list" 
                           >
                           </CSelect>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="setting_card_mobile">
                  
                     
                     <div class="form-group ">
                        <label style="float: left; margin-top: 6px; margin-right: 5px;">{{ $t('Username') }}</label>
                        <CInput class="odd-filter-inputbox" :value="loggedInUser.display_name" readonly></CInput>
                     </div>                      
                     <hr class="profile_hr"/>
                     <div class="form-group user-avatar-wrapper">
                        <label class="select_avatar_label">{{ $t('Select Avatar') }}</label>
                        <div class="user-avatar">
                            <cropper
                                :boundary="{
                                    width: 220,
                                    height: 220
                                }"
                                :viewport="{
                                    width: 200,
                                    height: 200
                                }"
                                :resize="false"
                                :defaultAvatarSrc="imageUrl"
                                :zoom="true"
                                @cropped="cropped"
                            />
                        </div>
                     </div>
                     <hr class="profile_hr"/>
                     <div class="form-group ">
                        <label style="float: left; margin-top: 6px; margin-right: 5px;">{{ $t('Alias') }}:</label>
                          <CInput
                              class="alias_label"
                              :key="JSON.stringify(loggedInUser)"
                              
                              :value="model.alias"
                              :isValid="validationState['alias'] && validationState['alias'].state"
                              :invalidFeedback="validationState['alias'] && validationState['alias'].text"
                              @update:value="model.alias=$event, validateField('alias')"
                          />
                     </div>
                     <div class="form-group ">
                        <label style="float: left; margin-top: 6px; margin-right: 5px;">{{ $t('Currency') }}</label>
                        <CSelect
                            :value.sync = "mycurrency"
                            :options= "currency_list"
                        >
                        </CSelect>
                     </div>
                     <div class="form-group ">
                        <label style="float: left; margin-top: 6px; margin-right: 5px;">{{ $t('Language') }}</label>
                        <CSelect
                            :value.sync = "mylang"
                            :options = "lang_list"
                            @update:value = "changeLocale"

                        >
                        </CSelect>
                     </div>
                     
                     <div class="form-group ">
                        <label style="float: left; margin-top: 6px; margin-right: 5px;">{{ $t('Timezone') }}:</label>
                        <CSelect
                            :value.sync = "mytimezone"
                            :options = "timezone_list" 
                        >
                        </CSelect>
                     </div>
                  
               </div>
           </div>
           <template #modal-footer="{ ok, cancel, hide }">
               <div class="form-group ">
                   <b-form-checkbox  v-model="notAskMore" switch>
                     {{ $t("Don't ask more in future") }}
                   </b-form-checkbox>
               </div>
                <b-button size="sm" variant="success" @click="ok()">
                    {{ $t('OK') }}
                </b-button>
                <b-button size="sm" variant="danger" @click="cancel()">
                    {{ $t('Cancel') }}
                </b-button> 
            </template>
        </b-modal>
   </div>
</template>

<script>
   import { mapState, mapActions, mapGetters } from 'vuex';
   import Cropper from "@/components/Cropper";
   import validationMixin from '@/mixins/common/validationMixin';
   import swal from "sweetalert2";
   import {displaySuccess, displayError} from '@/helpers/message';
   import i18n from '@/plugins/i18n';

   export default {
      mixins: [validationMixin],
      components: {
         Cropper,
      },
      data() {
         return {
               from: null,
               prevRoute: null,
               video_link: '',
               notAskMore: false,
               model: {
                 alias: '',
                 avatar: ''
               },
               loading: false,
               loadingTimer: '',
               show: false,
               validationState: {},
               lang_list: [
                  { value: 'en', language: 'en', label: 'English' },
                  { value: 'es', language: 'es', label: 'Español' },
                  { value: 'it', language: 'en', label: 'Italian' },
                  { value: 'pt', language: 'en', label: 'Português' },
                  { value: 'fr', language: 'en', label: 'Française' },
                  { value: 'ru', language: 'en', label: 'Pусский' },
                  { value: 'de', language: 'en', label: 'Deutsche' }
               ],
               goal_sound: true,
               alert_sound: true,
               Pages: [],
               default_bf: 0,
               mycurrency: 'Euro',
               mylang: 'en',
               mytimezone: 0,
               //lang_list: ['English', 'Spanish', 'Portuguese'],
               currency_list: [          
                   "ALL" ,         
                   "ANG" ,          
                   "ARS" ,
                   "AUD" ,
                   "AWG" ,
                   "AZN" ,
                   "BAM" ,
                   "BBD" ,          
                   "BGN" ,          
                   "BND" ,
                   "BOB" ,
                   "BRL" ,
                   "BSD" ,
                   "BTC" ,          
                   "BWP" ,
                   "BYN" ,
                   "BYR" ,
                   "BZD" ,
                   "CAD" ,          
                   "CHF" ,          
                   "CLP" ,
                   "CNY" ,
                   "COP" ,
                   "CRC" ,          
                   "CUP" ,          
                   "CZK" ,          
                   "DKK" ,
                   "DOP" ,          
                   "EGP" , 
                   "EUR" ,
                   "FJD" ,
                   "FKP" ,
                   "GBP" ,
                   "GIP" , 
                   "GTQ" ,
                   "GYD" ,
                   "HKD" ,
                   "HNL" ,
                   "HRK" ,          
                   "HUF" ,
                   "IDR" ,
                   "ILS" ,          
                   "INR" ,          
                   "ISK" ,          
                   "JMD" ,          
                   "JPY" ,
                   "KES" ,
                   "KGS" ,
                   "KHR" ,          
                   "KPW" ,
                   "KRW" ,          
                   "KYD" ,
                   "KZT" ,
                   "LAK" ,
                   "LBP" ,
                   "LKR" ,
                   "LRD" ,
                   "LVL" , 
                   "MKD" ,          
                   "MNT" ,            
                   "MUR" ,           
                   "MXN" ,
                   "MYR" ,          
                   "NAD" ,
                   "NGN" ,
                   "NIO" ,
                   "NOK" ,
                   "NPR" ,
                   "NZD" ,          
                   "PAB" ,
                   "PEN" ,          
                   "PHP" ,
                   "PKR" ,
                   "PLN" ,
                   "PYG" ,          
                   "RON" ,
                   "RSD" ,
                   "RUB" ,          
                   "SBD" ,
                   "SCR" ,          
                   "SEK" ,
                   "SGD" ,
                   "SHP" ,          
                   "SOS" ,
                   "SRD" ,          
                   "SYP" ,          
                   "THB" ,          
                   "TTD" ,
                   "TWD" ,
                   "TZS" ,
                   "UAH" ,
                   "UGX" ,
                   "USD" ,
                   "UYU" ,
                   "UZS" ,          
                   "VND" ,
                   "XCD" ,
                   "ZAR" 
               ],
               timezone_list: [
                   {"value": -12, "label": "(GMT-12:00) International Date Line West"},
                   {"value": -11, "label": "(GMT-11:00) Midway Island, Samoa"},
                   {"value": -10, "label": "(GMT-10:00) Hawaii"},
                   {"value": -9, "label": "(GMT-09:00) Alaska"},
                   {"value": -8, "label": "(GMT-08:00) Pacific Time (US & Canada)"},
                   {"value": -7, "label": "(GMT-07:00) Arizona"},
                   {"value": -6, "label": "(GMT-06:00) Saskatchewan"},
                   {"value": -5, "label": "(GMT-05:00) Indiana (East)"},
                   {"value": -4, "label": "(GMT-04:00) Atlantic Time (Canada)"},
                   {"value": -3, "label": "(GMT-03:00) Brasilia"},
                   {"value": -2, "label": "(GMT-02:00) Mid-Atlantic"},
                   {"value": -1, "label": "(GMT-01:00) Cape Verde Is."},
                   {"value": 0, "label": "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"},
                   {"value": 1, "label": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"},
                   {"value": 2, "label": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"},
                   {"value": 3, "label": "(GMT+03:00) Moscow, St. Petersburg, Volgograd"},
                   {"value": 4, "label": "(GMT+04:00) Abu Dhabi, Muscat"},
                   {"value": 5, "label": "(GMT+05:00) Islamabad, Karachi, Tashkent"},
                   {"value": 6, "label": "(GMT+06:30) Yangon (Rangoon)"},
                   {"value": 7, "label": "(GMT+07:00) Bangkok, Hanoi, Jakarta"},
                   {"value": 8, "label": "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi"},
                   {"value": 9, "label": "(GMT+09:00) Osaka, Sapporo, Tokyo"},
                   {"value": 10, "label": "(GMT+10:00) Canberra, Melbourne, Sydney"},
                   {"value": 11, "label": "(GMT+11:00) Magadan, Solomon Is., New Caledonia"},
                   {"value": 12, "label": "(GMT+12:00) Fiji, Kamchatka, Marshall Is"},
               ],

               tutorial_url: "",
                instagram: {
                    check: false,
                    url: ""
                },
                facebook: {
                    check: false,
                    url: ""
                },
                whatsapp: {
                    check: false,
                    url: ""
                },
                youtube: {
                    check: false,
                    url: ""
                },
                telegram: {
                    check: false,
                    url: ""
                },
         };
      },
      beforeRouteEnter(to, from, next) {
        next(vm => {
          vm.prevRoute = from
        })
      },
      methods: {
         ...mapActions([
             'updateProfile',
             'checkAliasIfDuplicate',
             'me'
         ]),
         toggleSidebar() {
            if (!this.sidebarShow) {
               this.$store.commit('set', ['sidebarShow', true]);
            }
         },
         set_videoLink() {
            // var base_url = 'https://sospesosoftwares.com/video-tutorials/';
            // var lang = localStorage.getItem('lang');
            // if (lang != 'en')
            //    this.video_link = base_url + '?lang=' + lang;
            // else
            //    this.video_link = base_url;
            this.me().then(data => {
                if (data.status == "success") {
                  let userData = data.data;
                  if (userData.tutorial_url)
                    this.tutorial_url = userData.tutorial_url;
                  if (userData.instagram)
                    this.instagram = userData.instagram;
                  if (userData.facebook)
                    this.facebook = userData.facebook;
                  if (userData.whatsapp)
                    this.whatsapp = userData.whatsapp;

                  if (userData.youtube)
                    this.youtube = userData.youtube;
                  if (userData.telegram)
                    this.telegram = userData.telegram;

                  if (localStorage.getItem("user_id") == 0 ) {
                    this.tutorial_url = 'https://sospesosoftwares.com/video-tutorials/?lang=it';
                    this.facebook = {
                      check: true,
                      url: "https://www.facebook.com/nicolaTipster/"
                    }
                    this.youtube = {
                      check: true,
                      url: "https://www.youtube.com/channel/UCaZM3Z7h1Y0rUX-3YHt1K4w"
                    }
                  }
                }
                else {
                  this.$router.push("/pages/login");
                }
             }).catch(err => {
                console.log("error", err)
             });

         },

         async handleUpdate() {
            this.loading = true;
            const isValid = await this.checkValidation();
            if(!isValid)
               return;
            let params = {};
            if(this.model.avatar) {
               params['avatar'] = this.model.avatar;
            }
            params['alias'] = this.model.alias;
            
            if(!this._.isEmpty(params)) {
                 
               this.updateProfile(params).then(res => {
                  this.model.avatar = '';
                  this.loading = false;
                  displaySuccess(res);
               }).catch(err => {
                  displayError(res);
               });
            }
            else {
               this.loading = false;
            }
         },
         cropped(e) {
            this.model.avatar = e;
         },

         lang_setting() {
            i18n.locale = localStorage.getItem('lang');
         },
         changeLocale(locale) {
            console.log(locale)
            i18n.locale = locale;
            localStorage.setItem('lang', locale);
         },
         user_setting() {
           const token = localStorage.getItem("token");
           const user_id = localStorage.getItem("user_id");
           console.log(token);
           if(!token){
             this.$router.push("/pages/login")
           } else {
             
           }
           var post_data = {
             "user_id": user_id          
           }

           let apiURL = `${process.env.VUE_APP_URL}get_usersetting`;

           axios
             .post(apiURL, post_data)
             .then((res) => {
               console.log(res.data.data.default_bf)
               if (res.data.data) {
                 this.default_bf = res.data.data.default_bf;
                 this.mycurrency = res.data.data.mycurrency;
                 this.mytimezone = res.data.data.mytimezone;
                 this.mylang = res.data.data.mylang;
                 this.goal_sound = res.data.data.goal_sound;
                 this.alert_sound = res.data.data.alert_sound;
                 this.notAskMore = res.data.data.notAskMore;

               }
               
             })
                   
             .catch((error) => {
               console.log('request catch: ', error);
             });
         },
         handleOk(bvModalEvt) {
             bvModalEvt.preventDefault()
             this.handleSubmit()
         },
         async handleSubmitForm() {
           const token = localStorage.getItem("token");
           const user_id = localStorage.getItem("user_id");
           console.log(token);
           if(!token){
             this.$router.push("/pages/login")
           } else {
             
           }
       
           var default_bf = this.default_bf;

           var mycurrency = this.mycurrency;
           var mytimezone = this.mytimezone;
           var mylang = this.mylang;
           var goal_sound = this.goal_sound;
           var alert_sound = this.alert_sound;
           var notAskMore = this.notAskMore;

           var post_data = {
             "user_id": user_id,
             // "default_bf": default_bf,
             "mycurrency": mycurrency,
             "mytimezone": mytimezone,
             "mylang": mylang,
             // "goal_sound": goal_sound,
             // "alert_sound": alert_sound,
             "notAskMore": notAskMore
           }

           let apiURL = `${process.env.VUE_APP_URL}usersetting`;

           axios
             .post(apiURL, post_data)
             .then((res) => {
               console.log(res.data)
               localStorage.setItem('lang', this.mylang)
               localStorage.setItem('mytimezone', this.mytimezone)
             })
                   
             .catch((error) => {
               console.log('request catch: ', error);
             });
           
         },
         handleSubmit() {
               this.handleUpdate();
               this.handleSubmitForm();

               // Hide the modal manually
               this.$nextTick(() => {
                 this.$bvModal.hide("b-modal");
               })
               
               setTimeout(() => {  
                  location.reload();
               }, 6000);
         },
         
      },
      
      computed: {
         ...mapState(['sidebarMinimize']),
         ...mapGetters(['loggedInUser']),
         imageUrl() {
             let result = 'img/avatars/default-avatar.jpg';
             let storedUrl = localStorage.getItem('storedAvatar');
             if(storedUrl)
                 result = storedUrl;
             if(this.loggedInUser.avatar)
                 result = this.loggedInUser.avatar;
             if(this.imgDataUrl)
                 result = this.model.avatar;
             return result;
         },
         validationRules() {
             return {
                 alias: [{
                     minLength: 5,
                     maxLength: 12,
                     message: 'Alias name must have a number between 5 and 12 letters!'
                 }, {
                     unique: true,
                     message: 'Someone is already using this alias!',
                     func: this.checkAliasIfDuplicate
                 }]
             }
         }
      },
        
      created() {
         this.set_videoLink();
         this.user_setting();
         this.lang_setting();
      },
      beforeRouteEnter(to, from, next) {
           next((vm) => {
               vm.from = from;
           });
       },
      mounted() {
         this.toggleSidebar(); // Add sidebar toggle on mount for opening

         setTimeout(() => {
            
            if (this.from.name == "Login"){
               if (!this.notAskMore)
                  this.$root.$emit("bv::show::modal", "b-modal");
            }
            
         }, 5000);
         
         
      },
      watch: {
         loggedInUser: {
            deep: true,
            immediate: true,
            handler(val) {
               this.model.alias = this.loggedInUser.alias;
            }
         }
      },      
   }

</script>
<style scope>
.section-header {
   padding-top: 10px; 
   margin-bottom: 20px; 
   font-size: 30px;
   border-style: solid;
   border-width: 0px 0px 2px 0px; 
   border-color: #FFFFFF; 
   margin-left: 10px; 
   margin-right: 10px;
}
.section-content {
   font-size: 17px; 
   margin-bottom: 20px; 
   line-height: 1.7;
   padding-bottom: 25px;
   padding-left:  15px;
   padding-right: 15px;
}
@media (max-width: 576px){
    .email_font{
        font-size:  13px;
    }
    .setting_card_mobile {
      display: block !important;
    }
    .setting_card {
        display: None !important;
    }
    
 }
 @media (min-width: 576px){
    .email_font{
        font-size:  13px;
    }
    .setting_card {
        width: 100%;
        padding: 15px 0;
    }
    .setting_card_mobile {
      display: None !important;
    }
    
 }
 .show_video {
   text-decoration: none; 
   font-size: 18px; 
   line-height: 1em;    
   letter-spacing: 0.3px;    
   background-color: #1722FF;    
   display: inline-block;    
   width: 138px;    
   height: 42px; 
   border-radius: 3px;
 }

 .show_video:hover {
   transform: scale(1.05);
 }

 .user-avatar-wrapper {
     margin: 0;   
 }
 .user-avatar {
     display: flex;
     justify-content: center;
 }
 user-avatar-wrapper user-avatar {
     display: flex;
     justify-content: center;
 }
 .social-link {
  width:  50px;
  margin-right: 10px;
  margin-left: 10px;
 }
</style>